<template>
  <div class="main" :class="{'main-hide-text': shrink}">
    <div class="single-page-con" :style="{width: '100%'}">
      <div class="single-page" style="margin-left: 0px;">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'app-main',
    computed: {
      // ...mapGetters([
      //   'userHeadImg',
      //   'name',
      //   'adminType'
      // ]),
      bgColor () {
        return this.theme === 'dark' ? '#484c4f' : '#ffffff';
      },
      iconColor () {
        return this.theme === 'dark' ? '#fff' : '#ffffff';
      }
    },
    data () {
      return {
        shrink: false,//是否收起侧边栏
        theme: 'light',
        userInfoStyle: 'user-dropdown-innercon',
        selectedMenuName: 'reportMain'
      }
    },
    methods: {
      /*
     * 选择菜单时触发
     */
      selectEvent (pathKey) {
        this.selectedMenuName = pathKey;
        this.$router.push({
          name: pathKey
        });
      }
    },
    mounted () {
    }
  }
</script>
<style lang="less">

    .main {
        position : absolute;
        width    : 100%;
        @media (max-width : 1024px) {
            width    : 1540px;
        }
        height   : 100%;
        .main-hide-text .layout-text {
            display : none;
        }
        &-content-container {
            position : relative;
        }
        &-header-con {
            box-sizing : border-box;
            position   : fixed;
            display    : block;
            //padding-left: 200px;
            width      : 100%;
            height     : 62px;
            z-index    : 23;
            box-shadow : 0 2px 1px 1px rgba(100, 100, 100, .1);
            transition : padding .3s;
        }
        &-breadcrumb {
            padding : 8px 15px 0;
        }
        &-menu-left {
            background : #464c5b;
            height     : 100%;
        }
        .tags-con {
            height     : 40px;
            z-index    : -1;
            overflow   : hidden;
            background : #f0f0f0;
            .tags-outer-scroll-con {
                position      : relative;
                box-sizing    : border-box;
                padding-right : 120px;
                width         : 100%;
                height        : 100%;
                .tags-inner-scroll-body {
                    position    : absolute;
                    padding     : 2px 10px;
                    overflow    : visible;
                    white-space : nowrap;
                    transition  : left .3s ease;
                }
                .close-all-tag-con {
                    position    : absolute;
                    right       : 0;
                    top         : 0;
                    box-sizing  : border-box;
                    padding-top : 8px;
                    text-align  : center;
                    width       : 110px;
                    height      : 100%;
                    background  : white;
                    box-shadow  : -3px 0 15px 3px rgba(0, 0, 0, .1);
                    z-index     : 10;
                }
            }
        }
        &-header {
            height     : 65px;
            background : #fff;
            box-shadow : 0 2px 0px 0px rgba(100, 100, 100, .1);
            position   : initial;
            z-index    : 11;
            left       : 200px;
            .navicon-con {
                margin  : 6px;
                display : inline-block;
            }
            .header-middle-con {
                position : absolute;
                left     : 60px;
                top      : 0;
                right    : 340px;
                bottom   : 0;
                padding  : 10px;
                overflow : hidden;
            }
            .header-avator-con {
                position : absolute;
                right    : -152px;
                top      : 0;
                height   : 100%;
                width    : 340px;
                .switch-theme-con {
                    display : inline-block;
                    width   : 40px;
                    height  : 100%;
                }
                .message-con {
                    display    : inline-block;
                    width      : 30px;
                    padding    : 18px 0;
                    text-align : center;
                    cursor     : pointer;
                    i {
                        vertical-align : middle;
                    }
                }
                .change-skin {
                    font-size     : 14px;
                    font-weight   : 500;
                    padding-right : 5px;
                }
                .switch-theme {
                    height : 100%;
                }
                .user-dropdown {
                    &-menu-left {
                        position : absolute;
                        right    : 170px;
                        top      : 23px;
                        width    : 73px;
                        height   : 50%;
                        cursor   : pointer;
                        color    : #2d8cf0;
                    }
                    &-menu-con {
                        //position: absolute;
                        right        : 0;
                        top          : 62px;
                        width        : 150px;
                        height       : 100%;
                        margin-right : 14px;
                        .main-user-name {
                            display        : inline-block;
                            width          : 40px;
                            word-break     : keep-all;
                            white-space    : nowrap;
                            vertical-align : middle;
                            overflow       : hidden;
                            text-overflow  : ellipsis;
                            text-align     : right;
                            font-size      : 14px;
                            color          : #888fa0;
                            font-weight    : 400;
                            line-height    : 40px;
                        }
                    }
                    &-innercon {
                        height : 100%;
                        //padding-right: 14px;
                    }
                    &-innercon2 {
                        height     : 100%;
                        margin-top : 15px;
                    }
                }
                .full-screen-btn-con {
                    display    : inline-block;
                    width      : 30px;
                    padding    : 18px 0;
                    text-align : center;
                    cursor     : pointer;
                    i {
                        vertical-align : middle;
                    }
                }
                .lock-screen-btn-con {
                    display    : inline-block;
                    width      : 30px;
                    padding    : 18px 0;
                    text-align : center;
                    cursor     : pointer;
                    i {
                        vertical-align : middle;
                    }
                }
            }
        }
        .single-page-con {
            position         : absolute;
            //top: 62px;
            top              : 0px;
            right            : 0;
            bottom           : 0;
            //overflow         : auto;
            background-color : #eff1fa;
            z-index          : 100;
            transition       : left .3s;
            flex: 1 1 0;
            -webkit-flex: 1 1 0;
            display: flex;
            display: -ms-flexbox;
            display: -webkit-flex;
            -ms-flex-direction: column;
            overflow-x: hidden;
            overflow-y: hidden;

            .single-page{
                //padding: 0px 10px;
                //margin-left: 200px;
                width: 100%;
                margin-top: 15px;
                flex: 1 1 0;
                -webkit-flex: 1 1 0;
                display: flex;
                display: -ms-flexbox;
            }
        }
        &-copy {
            text-align : center;
            padding    : 10px 0 20px;
            color      : #9ea7b4;
        }

        .no-data {
            text-align     : center;
            //padding-top    : 12%;
            padding-top: 5%;
            padding-bottom : 4%;
            .no_pic {
                display : block;
                margin  : auto;
            }
            .txt {
                text-align  : center;
                margin      : auto;
                display     : inherit;
                color       : #a6b0c9;
                margin-top  : 40px;
                font-size   : 16px;
                font-weight : 400;
            }
        }
    }
</style>

<style lang="scss" scoped>
  .ivu-shrinkable-menu {
    height : 100%;
    width  : 100%;
  }

  .ivu-shrinkable-menu {
    height : 100%;
    width  : 100%;
  }

  .dropdownMenu {
    left        : 1764px;
    top         : 40px;
    position    : absolute;
    will-change : top, left;
  }

  .navicon-con .ivu-btn-text:focus {
    -webkit-box-shadow : 0 0 0 2px rgba(45, 140, 240, .2);
    box-shadow         : 0 0 0 0px rgba(45, 140, 240, .2);
  }

</style>

<style lang="scss">
  @import "../../../style/_layout";
</style>

<style lang="css">

  .ivu-select-dropdown {
    z-index : 9999;
  }

  .ivu-table .ivu-btn-text:focus {
    -webkit-box-shadow : 0 0 0 2px rgba(45, 140, 240, .2);
    box-shadow         : 0 0 0 0px rgba(45, 140, 240, .2);
  }

  .ivu-btn-primary {
    color            : #fff !important;
    background-color : #3e73f6 !important;
    border-color     : #295dde !important;
  }

  .ivu-page-item-active {
    background-color : #3e73f6 !important;
    border-color     : #295dde !important;
  }

  .ivu-shrinkable-menu .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
    color        : #4e5668;
    border-left  : 8px solid #3e73f6;
    border-right : unset !important;
    z-index      : 2;
  }

  .menu-wrap .ivu-menu-item {
    font-size   : 18px;
    height      : 60px;
    line-height : 30px;
  }

  .main .ivu-breadcrumb {
    font-size : 16px;
  }

  .main .ivu-card-head p, .ivu-card-head-inner {
    font-size : 16px;
  }

  .main .ivu-select-single .ivu-select-selection {
    height   : 40px;
    position : relative;
  }

  .main .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    display       : block;
    height        : 40px !important;
    line-height   : 40px !important;
    font-size     : 16px !important;
    overflow      : hidden;
    text-overflow : ellipsis;
    white-space   : nowrap;
    padding-left  : 8px;
    padding-right : 24px;
  }

  .main .ivu-breadcrumb > span:last-child {
    font-weight : unset !important;
    color       : #495060;
  }

  .ivu-message{
    top: 45% !important;
  }

</style>
